const desc = `<p class="c3" dir="rtl">
  <span class="c1"> אסתר מרגולין, נחמה פוחצ&#39;בסקי  </span
  ><span class="c2 bold">בוסתנאי</span><span class="c1"> תרצד ט  1934</span>
</p>`;

export default desc;
